import { render, staticRenderFns } from "./NavigablePane.vue?vue&type=template&id=2d8b32c8&scoped=true&"
import script from "./NavigablePane.vue?vue&type=script&lang=ts&"
export * from "./NavigablePane.vue?vue&type=script&lang=ts&"
import style0 from "./NavigablePane.vue?vue&type=style&index=0&id=2d8b32c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8b32c8",
  null
  
)

export default component.exports